// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","FooterLeft":"Footer_FooterLeft__1pDVi","FooterMiddle":"Footer_FooterMiddle__Mntxu","FooterRight":"Footer_FooterRight__7Y2aq"};